import { FETCH_ADMIN_USER, DESTROY_ADMIN_USER } from "../actionTypes";

export const fetchAdminUser = users => ({
  type: FETCH_ADMIN_USER,
  users
});

export const destroyAdminUser = key => ({
  type: DESTROY_ADMIN_USER,
  key
});